export function serviceSort() {
  const list = document.getElementById('service-list');
  const items = Array.from(list.querySelectorAll('.p-top-service__item'));
  const searchInput = document.getElementById('p-top-service__box-search-input');
  const tabButtons = document.querySelectorAll('.p-top-service__tab-btn');
  const recordsNum = document.querySelector('.p-top-service__box-records-num');
  const sortButton = document.querySelector('.p-top-service__box-sort');
  const modalTitle = document.querySelector('.p-top-service__modal-form-head-text');
  const modal = document.getElementById('p-top-service__modal');
  const filterForm = document.getElementById('p-top-service__modal-form');

  let currentKeyword = '';
  let currentFilters = {
    provider: null,
    line: null,
    immediate: null,
    support: null,
    guarantee: null
  };
  let sortOrder = 'asc';
  let currentSortOption = ''; // 現在の並び替えオプションを保存する変数
  
  function updateList() {
    const filterItemMap = {
      provider: {
        '労働組合': [0, 1, 2, 4],
        '弁護士': [0, 3, 4]
      },
      line: [0, 1, 2, 3, 4],
      immediate: [0, 1, 2, 3, 4],
      support: {
        '引っ越しサービス': [0]
      },
      guarantee: {
        'あり': [0, 1, 3, 4]
      }
    };

    let filtered = items.filter((item, index) => {
      const keywordMatch = currentKeyword === '' || item.textContent.includes(currentKeyword);

      // 各フィルター条件をチェック
      const providerIndices = filterItemMap.provider[currentFilters.provider] || [];
      const providerIndexMatch = currentFilters.provider ? providerIndices.includes(index) : true;

      const lineIndexMatch = filterItemMap.line.includes(index);

      const immediateIndexMatch = filterItemMap.immediate.includes(index);

      const supportIndices = filterItemMap.support[currentFilters.support] || [];
      const supportIndexMatch = currentFilters.support ? supportIndices.includes(index) : true;

      const guaranteeIndices = filterItemMap.guarantee[currentFilters.guarantee] || [];
      const guaranteeIndexMatch = currentFilters.guarantee ? guaranteeIndices.includes(index) : true;

      return keywordMatch && providerIndexMatch && lineIndexMatch && immediateIndexMatch && supportIndexMatch && guaranteeIndexMatch;
    });

    if (currentSortOption) {
      filtered.sort((a, b) => {
        if (currentSortOption === '申込数が多い順（当サイト経由）') {
          const customOrder = [
            '退職代行Jobs',
            '退職代行ヤメドキ',
            '退職代行ガーディアン',
            '弁護士法人ガイア',
            '退職代行トリケシ'
          ];
          const aIndex = customOrder.findIndex(name => a.textContent.includes(name));
          const bIndex = customOrder.findIndex(name => b.textContent.includes(name));
          return aIndex - bIndex;
        }
      
        if (currentSortOption === 'サービス料金が安い順') {
          const customOrder = [
            '退職代行ヤメドキ',
            '退職代行ガーディアン',
            '退職代行トリケシ',
            '退職代行Jobs',
            '弁護士法人ガイア'
          ];
          const aIndex = customOrder.findIndex(name => a.textContent.includes(name));
          const bIndex = customOrder.findIndex(name => b.textContent.includes(name));
          return aIndex - bIndex;
        }
      
        if (currentSortOption === 'サービス料金が高い順') {
          const customOrder = [
            '弁護士法人ガイア',
            '退職代行Jobs',
            '退職代行トリケシ',
            '退職代行ガーディアン',
            '退職代行ヤメドキ'
          ];
          const aIndex = customOrder.findIndex(name => a.textContent.includes(name));
          const bIndex = customOrder.findIndex(name => b.textContent.includes(name));
          return aIndex - bIndex;
        }
      
        // デフォルトの名前順（昇順 or 降順）
        const aText = a.textContent;
        const bText = b.textContent;
        return sortOrder === 'asc' ? aText.localeCompare(bText) : bText.localeCompare(aText);
      });
    }
    
    list.innerHTML = '';

  // filtered の中から表示対象（最大5件）を再追加
  filtered.slice(0, 5).forEach(item => {
    item.style.display = ''; // 表示
    list.appendChild(item); // 並べ替えた順に追加
  });

    items.forEach(item => item.style.display = 'none');
    filtered.slice(0, 5).forEach(item => item.style.display = '');
    recordsNum.textContent = filtered.length; // 全体の件数を表示
  }
  
  
  // ✅ キーワードを入力したらリストを更新
  searchInput.addEventListener('input', (e) => {
    currentKeyword = e.target.value;
    updateList();
  });

  // ✅ フィルター候補の定義
  const filterOptions = {
    provider: ['労働組合', '弁護士'],
    line: ['あり'],
    immediate: ['可'],
    support: ['引っ越しサービス'],
    guarantee: ['あり']
  };
  
  // ✅ ラジオボタンを生成する関数
  function renderFilterOptions(type) {
    const options = filterOptions[type] || [];

    const existingUl = filterForm.querySelector('.p-top-service__modal-list');
    if (existingUl) {
      existingUl.remove();
    }

    const ul = document.createElement('ul');
    ul.className = 'p-top-service__modal-list';

    options.forEach(opt => {
      const li = document.createElement('li');
      li.className = 'p-top-service__modal-list-item';

      const label = document.createElement('label');
      label.className = 'p-top-service__modal-label';

      const input = document.createElement('input');
      input.type = 'radio';
      input.name = type; // フィルタータイプを名前に設定
      input.value = opt;
      input.className = 'p-top-service__modal-label-input';

      if (opt === currentFilters[type]) {
        input.checked = true;
      }

      label.appendChild(input);
      label.appendChild(document.createTextNode(opt));
      li.appendChild(label);
      ul.appendChild(li);
    });

    const resetLi = document.createElement('li');
    resetLi.className = 'p-top-service__modal-list-item';

    const resetLabel = document.createElement('label');
    resetLabel.className = 'p-top-service__modal-label';

    const resetInput = document.createElement('input');
    resetInput.type = 'radio';
    resetInput.name = type;
    resetInput.value = '';
    resetInput.className = 'p-top-service__modal-label-input';

    if (currentFilters[type] === null) {
      resetInput.checked = true;
    }

    resetLabel.appendChild(resetInput);
    resetLabel.appendChild(document.createTextNode('選択しない'));
    resetLi.appendChild(resetLabel);
    ul.appendChild(resetLi);

    filterForm.appendChild(ul);
  }

  // フィルターフォームの変更を監視
  filterForm.addEventListener('change', (e) => {
    if (e.target.name) {
      currentFilters[e.target.name] = e.target.value || null;
      updateList();

      // 選択状態に応じてクラスを追加
      tabButtons.forEach(btn => {
        const type = btn.dataset.filterType;
        if (currentFilters[type] && currentFilters[type] !== '') {
          btn.classList.add('active-filter');
        } else {
          btn.classList.remove('active-filter');
        }
      });
    }
  });

  // 並び替えオプションを定義
  const sortOptions = [
    { value: '申込数が多い順（当サイト経由）', text: '申し込みが多い' },
    { value: 'サービス料金が安い順', text: '料金が安い' },
    { value: 'サービス料金が高い順', text: '料金が高い' }
  ];

  // 並び替えオプションを表示する関数
  function renderSortOptions() {
    const existingUl = filterForm.querySelector('.p-top-service__modal-list');
    if (existingUl) {
        existingUl.remove();
    }
    
    const ul = document.createElement('ul');
    ul.className = 'p-top-service__modal-list';

    sortOptions.forEach(opt => {
      const li = document.createElement('li');
      li.className = 'p-top-service__modal-list-item';

      const label = document.createElement('label');
      label.className = 'p-top-service__modal-label';

      const input = document.createElement('input');
      input.type = 'radio';
      input.name = 'sort'; // 並び替え用の名前を設定
      input.value = opt.value;
      input.className = 'p-top-service__modal-label-input';

      // 現在の選択状態を復元
      if (opt.value === currentSortOption) {
        input.checked = true;
      }

      label.appendChild(input);
      label.appendChild(document.createTextNode(opt.value));
      li.appendChild(label);
      ul.appendChild(li);
    });

    const fallbackTitle = '条件で絞り込む';
    const titleP = document.createElement('p');
    titleP.className = 'p-top-service__modal-form-head-text';
    titleP.textContent = modalTitle ? modalTitle.textContent : fallbackTitle;


    // 「選択しない」オプションを追加
    const resetLi = document.createElement('li');
    resetLi.className = 'p-top-service__modal-list-item';

    const resetLabel = document.createElement('label');
    resetLabel.className = 'p-top-service__modal-label';

    const resetInput = document.createElement('input');
    resetInput.type = 'radio';
    resetInput.name = 'sort';
    resetInput.value = '';
    resetInput.className = 'p-top-service__modal-label-input';

    // デフォルトで「選択しない」をチェック
    if (currentSortOption === '') {
      resetInput.checked = true;
    }

    resetLabel.appendChild(resetInput);
    resetLabel.appendChild(document.createTextNode('選択しない'));
    resetLi.appendChild(resetLabel);
    ul.appendChild(resetLi);

    filterForm.appendChild(ul);
  }

  // 並び替えオプションの変更を監視
  filterForm.addEventListener('change', (e) => {
    if (e.target.name === 'sort') {
      currentSortOption = e.target.value; // 選択されたオプションを保存
      const sortButtonText = sortButton.querySelector('span'); // ボタン内の span 要素を選択

      const selectedOption = sortOptions.find(opt => opt.value === currentSortOption);
      if (selectedOption) {
        sortButton.classList.add('active-sort');
        sortButtonText.textContent = selectedOption.text; // 短いテキストをボタンに表示
      } else {
        sortButton.classList.remove('active-sort');
        sortButtonText.textContent = '並び替え'; // デフォルトのテキストに戻す
      }

      updateList();
    }
  });

  // 🔘 タブクリックでモーダルを開き、内容を差し替える
  tabButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      const type = btn.dataset.filterType;
      renderFilterOptions(type);
      modal.classList.add('show');
      modal.style.display = 'block';
      
      // タイトルをセット（ボタン内のテキストをそのまま使う）
      const btnText = btn.querySelector('span')?.textContent || btn.textContent;
      modalTitle.textContent = `${btnText}`; // お好みで文章調整OK
    });
  });

  modal.addEventListener('click', (e) => {
    // クリックされた場所が modal-inner の外だったら閉じる
    if (!e.target.closest('.p-top-service__modal-inner')) {
      modal.classList.remove('show');
      setTimeout(() => {
        modal.style.display = 'none';
      }, 300);
    }
  });

  function openModal() {
    modal.classList.remove('is-close');
    modal.classList.add('is-open');
  }
  function closeModal() {
    modal.classList.remove('is-open');
    modal.classList.add('is-close');
    setTimeout(() => {
      modal.style.display = 'none';
    }, 300);
  }
  
  // 並び替えボタンをクリックしたときにモーダルを表示
  sortButton.addEventListener('click', () => {
    // 並び替えオプションを表示
    renderSortOptions();

    // モーダルを表示するロジック
    modal.classList.add('show');
    modal.style.display = 'block';

    // タイトルをセット（お好みで調整可能）
    modalTitle.textContent = '並び替えオプションを選択';
  });

  updateList();

  // すべての p-top-service__item 要素を取得
  const serviceItems = document.querySelectorAll('.p-top-service__item');

  // 各要素を定数として定義
  const serviceItem1 = serviceItems[0];
  const serviceItem2 = serviceItems[1];
  const serviceItem3 = serviceItems[2];
  const serviceItem4 = serviceItems[3];
  const serviceItem5 = serviceItems[4];
}